import type { LoadTimeTrackData } from "common-types";
import { send } from "./sender";

export function sendTimeMeter(
  { event, payload }: LoadTimeTrackData,
  alias?: string,
) {
  const suffix = payload.slotName ? `_${payload.slotName}` : "";
  const name = alias ?? event;

  send("time", {
    action: `${name}${suffix}`,
    duration: Math.round(payload.time),
  });
}
